import { render } from "./Advice.vue?vue&type=template&id=a741883e"
import script from "./Advice.vue?vue&type=script&lang=js"
export * from "./Advice.vue?vue&type=script&lang=js"

import "./Advice.vue?vue&type=style&index=0&id=a741883e&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__